import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class WooCommerceGenderMapApiClient extends AdvancedApiClient {

    static entityType = "WooCommerceGenderMap"

    constructor(token, genderId, id) {
        super();

        this.setEntityType(WooCommerceGenderMapApiClient.entityType)

        if(id !== undefined && id !== null) {
            this.setRoute("/api/v1/gender/{gid}/woocommerce-map/{id}")
                .setRouteParam("gid", genderId)
                .setRouteParam("id", id);
        } else {
            this.setRoute("/api/v1/gender/{gid}/woocommerce-map")
                .setRouteParam("gid", genderId);
        }
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}